/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';

function MembershipFAQ({ noHeader, lang }) {
  const [questions, setQuestions] = useState([]);
  const toggleAnswer = (id, e) => {
    e.preventDefault();
    const cloneQuestions = [...questions];
    cloneQuestions.forEach((faq) => {
      if (faq.id === id) {
        faq.isOpen = !faq.isOpen;
      }
    });
    setQuestions(cloneQuestions);
  };

  const faq = {
    en: [
      {
        id: 1,
        title: 'How do I join the Wild Orchard rewards program?',
        answer: 'Easy! Just create an account with your email and start earning every time you shop.',
      },
      {
        id: 3,
        title: 'Where can I track progress?',
        answer: 'You can track your progress by logging into your rewards account and going to your benefits page. When you level up to a new tier, you will see all the new perks on your benefits page!',
      },
      {
        id: 4,
        title: 'How is my membership status determined?',
        answer: 'You will be able to access basic Member benefits upon joining.',
      },
      {
        id: 5,
        title: 'How do I earn?',
        answer: 'Earn 1 point for every dollar spent on our website. Redeem these points for gift vouchers that you can spend on various Wild Orchard products',
      },
      {
        id: 6,
        title: 'Do tiers/points expire or reset?',
        answer: 'Tiers reset annually and points never expire.',
      },
      {
        id: 7,
        title: 'Who do I reach out to for additional questions?',
        answer: 'Email ' + process.env.CLIENT_EMAIL + ' or call 914 602 0229.',
      },
    ],
  };

  useEffect(() => {
    setQuestions(faq.en);
  }, []);

  return (
    <div className="asset-faq">
      {!noHeader
      && (
      <div className="benefits-summary__header">
        <div className="benefits-summary__header--title">
          <span>FAQ</span>
        </div>
      </div>
      )}
      {questions.map((faq) => (
        <div
          key={faq.id}
          className="asset-faq__item">
          {faq.isOpen
            ? (
              <a
                className="asset-faq__toggle"
                href="#"
                onClick={(e) => toggleAnswer(faq.id, e)}>
                -
              </a>
            )
            : (
              <a
                className="asset-faq__toggle"
                href="#"
                onClick={(e) => toggleAnswer(faq.id, e)}>
                +
              </a>
            )}
          <div
            className="asset-faq__item--question"
            onClick={(e) => toggleAnswer(faq.id, e)}>
            {faq.title}
          </div>
          <div
            className={faq.isOpen ? 'asset-faq__item--answer -open' : 'asset-faq__item--answer'}
            dangerouslySetInnerHTML={{ __html: faq.answer }}>
          </div>
        </div>
      ))}
      
    </div>
  );
}

export default MembershipFAQ;
